export default "__VITE_ASSET__ClWEzruR__"